import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/gsjs_bg.png';
import _imports_1 from '@/assets/img/title.png';
import _imports_2 from '@/assets/img/c_jj.png';
const _withScopeId = n => (_pushScopeId("data-v-03011e5c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_3 = {
  class: "company_jj"
};
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"jieshao\" data-v-03011e5c><h2 data-v-03011e5c>公司<b data-v-03011e5c>简介</b></h2><p data-v-03011e5c> 公司本着以人为本的管理模式,制定了完善的人性化激励机制,同时吸收和培养了一批优秀的管理人才。 </p><div class=\"flex\" data-v-03011e5c><div class=\"company_zl\" data-v-03011e5c><img class=\"title\" src=\"" + _imports_1 + "\" alt=\"\" data-v-03011e5c><div class=\"info\" data-v-03011e5c> 公司专注软件和信息技术服务业、电信增值产品运营、计算机信息技术咨询、产品运营、互联网资源整合、自媒体运营、APP推广服务、音乐内容推广合作、渠道联盟运营等，在各个领域都有不俗战绩；公司本着以人为本的管理模式，制定了完善的人性化激励机制，同时吸收和培养了一批优秀的管理人才。本着诚信、创新、严谨、高效的经营理念，面对广阔但竞争激烈多变的市场，公司将对核心业务进行深度挖掘，寻求多元化的业务发展模式。 </div></div><div style=\"width:50%;\" data-v-03011e5c><img style=\"height:100%;\" src=\"" + _imports_2 + "\" alt=\"\" data-v-03011e5c></div></div></div>", 1);
const _hoisted_5 = {
  class: "jieshao"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [/*#__PURE__*/_createTextVNode("团队"), /*#__PURE__*/_createElementVNode("b", null, "介绍")], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 高效的客户服务团队：客户服务团队是业务的重要支撑力量，高效、专业的客户服务团队提供24小时在线的客服服务，并确保客服人员具备专业技能和良好的沟通能力，能够及时响应用户的咨询和投诉。 ", -1));
const _hoisted_8 = {
  class: "flex"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "msg"
}, [/*#__PURE__*/_createElementVNode("h3", null, "数据驱动增长中心"), /*#__PURE__*/_createTextVNode(" 搭建用户行为轻量化分析平台，结合ROI预测模型优化内容投放。团队以1名数据师+3名分析师为核心，利用开源算法库将推荐转化率提升至行业平均1.8倍。 ")], -1));
const _hoisted_11 = {
  class: "box"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "msg"
}, [/*#__PURE__*/_createElementVNode("h3", null, "轻量化通信技术组"), /*#__PURE__*/_createTextVNode(" 聚焦5G切片与物联网通信优化，开发低成本高兼容性传输方案。团队由全栈工程师与通信协议专家组成，支持中小型文旅/教育项目快速部署。 ")], -1));
const _hoisted_14 = ["src"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "msg"
}, [/*#__PURE__*/_createElementVNode("h3", null, "敏捷数字内容工作室"), /*#__PURE__*/_createTextVNode(" 基于AIGC工具链与轻量级XR引擎，实现72小时短视频/互动剧原型开发。团队含设计师兼编剧的多面手，主攻文旅短视频、品牌营销等垂直赛道。 ")], -1));
const _hoisted_16 = {
  class: "box"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "msg"
}, [/*#__PURE__*/_createElementVNode("h3", null, "文娱场景运营组"), /*#__PURE__*/_createTextVNode(" 整合线下空间与线上社群的轻运营模式，策划剧本杀×AR导览等融合玩法。成员含新媒体运营+社区BD复合人才。 ")], -1));
const _hoisted_19 = ["src"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "msg"
}, [/*#__PURE__*/_createElementVNode("h3", null, "垂直行业合作部"), /*#__PURE__*/_createTextVNode(" 主推“通信+文旅”模块化解决方案，定制景区数字导览、企业虚拟发布会等服务。团队兼具BD谈判与技术方案设计能力。 ")], -1));
import { reactive, ref, onMounted } from 'vue';
import Headers from "@/components/header/index.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({});
    const selectedCard = ref(3);
    const selectCard = cardNumber => {
      selectedCard.value = cardNumber;
    };
    onMounted(() => {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Headers, {
        class: "headers"
      }), _hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        class: _normalizeClass(["box box1", {
          'selected': selectedCard.value === 0
        }]),
        style: {
          "width": "25%"
        },
        onClick: _cache[0] || (_cache[0] = $event => selectCard(0))
      }, [_createElementVNode("img", {
        src: selectedCard.value === 0 ? require('@/assets/img/a1.png') : require('@/assets/img/b1.png'),
        alt: ""
      }, null, 8, _hoisted_9), _hoisted_10], 2), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        class: _normalizeClass(["card", {
          'selected': selectedCard.value === 1
        }]),
        onClick: _cache[1] || (_cache[1] = $event => selectCard(1))
      }, [_createElementVNode("img", {
        src: selectedCard.value === 1 ? require('@/assets/img/a2.png') : require('@/assets/img/b2.png'),
        alt: ""
      }, null, 8, _hoisted_12), _hoisted_13], 2), _createElementVNode("div", {
        class: _normalizeClass(["card", {
          'selected': selectedCard.value === 2
        }]),
        onClick: _cache[2] || (_cache[2] = $event => selectCard(2)),
        style: {
          "bottom": "0"
        }
      }, [_createElementVNode("img", {
        src: selectedCard.value === 2 ? require('@/assets/img/a3.png') : require('@/assets/img/b3.png'),
        alt: ""
      }, null, 8, _hoisted_14), _hoisted_15], 2)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
        class: _normalizeClass(["card", {
          'selected': selectedCard.value === 3
        }]),
        onClick: _cache[3] || (_cache[3] = $event => selectCard(3))
      }, [_createElementVNode("img", {
        src: selectedCard.value === 3 ? require('@/assets/img/a4.png') : require('@/assets/img/b4.png'),
        alt: ""
      }, null, 8, _hoisted_17), _hoisted_18], 2), _createElementVNode("div", {
        class: _normalizeClass(["card", {
          'selected': selectedCard.value === 4
        }]),
        onClick: _cache[4] || (_cache[4] = $event => selectCard(4)),
        style: {
          "bottom": "0"
        }
      }, [_createElementVNode("img", {
        src: selectedCard.value === 4 ? require('@/assets/img/a5.png') : require('@/assets/img/b5.png'),
        alt: ""
      }, null, 8, _hoisted_19), _hoisted_20], 2)])])])])]);
    };
  }
});